import Vue from 'vue'
import i18n from '@/i18n'

export default store => {
  store.subscribe((mutation) => {
    if (mutation.type === 'i18n/SET_LOCALE') {
      const language = Vue.i18n.locale()
      if (language) {
        i18n.setHtmlTagLangAndRtl(language)
      }
    }
  })
}
